import en from './en';
import id from './id';

export const dictionaryList = {
  en,
  id,
};

export const languageOptions = [
  { id: 'en', text: 'English' },
  { id: 'id', text: 'Indonesia'}
];
